import React from 'react';
import Loading from '../Loading';
import { Backdrop } from './styles';

const BackdropLoading = () => {
  return (
    <Backdrop>
      <Loading />
    </Backdrop>
  );
};

export default BackdropLoading;
